/**
 * Admin Bonus Contracts - Database-First Zod Schemas
 *
 * SOURCE OF TRUTH: PostgreSQL stored procedures and tables
 * Generated from MCP queries on 2026-01-02
 *
 * Related DB objects:
 * - get_current_bonus_settings()
 * - set_bonus_settings(p_percentage integer, p_first_time_enabled boolean, p_staff_id varchar)
 * - Table: bonus_settings
 *
 * Table schema (bonus_settings):
 * - id: integer NOT NULL (serial)
 * - bonus_percentage: integer NOT NULL
 * - first_time_bonus_enabled: boolean NOT NULL DEFAULT true
 * - staff_id: varchar NULL
 * - created_at: timestamptz DEFAULT now()
 * - referee_conversion_percent: integer NULL DEFAULT 0
 *
 * Constraint: valid_bonus_percentage CHECK ((bonus_percentage >= 0) AND (bonus_percentage <= 100))
 */
import { z } from 'zod';
// =============================================================================
// STORED PROCEDURE RESULTS
// =============================================================================
/**
 * get_current_bonus_settings() result
 *
 * SQL: SELECT * FROM get_current_bonus_settings()
 * Returns: TABLE(bonus_percentage integer, first_time_bonus_enabled boolean, staff_id varchar, created_at timestamptz)
 */
export const getCurrentBonusSettingsResultSchema = z.object({
    bonus_percentage: z.number().int().min(0).max(100),
    first_time_bonus_enabled: z.boolean(),
    staff_id: z.string().nullable(),
    created_at: z.coerce.date(),
});
/**
 * set_bonus_settings() result
 *
 * SQL: SELECT * FROM set_bonus_settings($1, $2, $3)
 * Returns: TABLE(success boolean, message text)
 */
export const setBonusSettingsResultSchema = z.object({
    success: z.boolean(),
    message: z.string(),
});
// =============================================================================
// API REQUEST/RESPONSE SCHEMAS
// =============================================================================
/**
 * GET /api/admin/bonus response data
 * Matches backend controller response
 */
export const bonusConfigResponseDataSchema = z.object({
    percentage: z.number().int().min(0).max(100),
    firstTimeBonusEnabled: z.boolean(),
    refereeConversionPercent: z.number().int().min(0).max(100),
    updatedBy: z.string().nullable(),
    updatedAt: z.string(), // ISO string
});
/**
 * POST /api/admin/bonus request body
 * Matches backend controller validation
 */
export const updateBonusRequestSchema = z.object({
    percentage: z.number().int().min(0).max(100),
    firstTimeBonusEnabled: z.boolean().optional(),
    refereeConversionPercent: z.number().int().min(0).max(100).optional(),
});
/**
 * POST /api/admin/bonus response data
 * Matches backend controller response
 */
export const updateBonusResponseDataSchema = z.object({
    percentage: z.number().int().min(0).max(100),
    firstTimeBonusEnabled: z.boolean(),
    refereeConversionPercent: z.number().int().min(0).max(100),
    updatedBy: z.string(),
    updatedAt: z.string(), // ISO string
});
// =============================================================================
// BONUS ENTITY (full table row)
// =============================================================================
/**
 * BonusSettings table entity
 * Full row from bonus_settings table
 */
export const bonusSettingsEntitySchema = z.object({
    id: z.number().int(),
    bonus_percentage: z.number().int().min(0).max(100),
    first_time_bonus_enabled: z.boolean(),
    staff_id: z.string().nullable(),
    created_at: z.coerce.date(),
    referee_conversion_percent: z.number().int().nullable(),
});
//# sourceMappingURL=bonus.js.map